import cn from 'classnames';

import { EColorMap } from '../constants/colorMap';
import { IConDefaultType } from '../types';

interface IChangeIconProps extends IConDefaultType {}

function ChangeIcon({ color, className, size = 24, rotate, flip }: IChangeIconProps) {
  const fill = color || EColorMap.gray_0;
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 8.99402C3.26573 8.99402 3.52054 9.09979 3.70816 9.28797L5.70816 11.2939C6.0981 11.6851 6.09716 12.3182 5.70605 12.7082C5.31494 13.0981 4.68178 13.0972 4.29184 12.706L3 11.4103L1.70816 12.706C1.31822 13.0972 0.685056 13.0981 0.293949 12.7082C-0.0971572 12.3182 -0.0981025 11.6851 0.291839 11.2939L2.29184 9.28797C2.47946 9.09979 2.73427 8.99402 3 8.99402Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.2939 11.2918C18.6851 10.9019 19.3182 10.9028 19.7082 11.2939L21 12.5897L22.2918 11.2939C22.6818 10.9028 23.3149 10.9019 23.7061 11.2918C24.0972 11.6818 24.0981 12.3149 23.7082 12.7061L21.7082 14.712C21.5205 14.9002 21.2657 15.006 21 15.006C20.7343 15.006 20.4795 14.9002 20.2918 14.712L18.2918 12.7061C17.9019 12.3149 17.9028 11.6818 18.2939 11.2918Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.27045 2.38078C11.258 1.81531 13.3714 1.881 15.3202 2.56878C17.269 3.25655 18.9571 4.53247 20.1529 6.22073C21.3488 7.90895 21.9939 9.9268 22 11.9971L22 12L22 14.006C22 14.5583 21.5523 15.006 21 15.006C20.4478 15.006 20 14.5583 20 14.006V12.0014C19.9948 10.3434 19.478 8.72792 18.5209 7.37678C17.5635 6.02527 16.2128 5.00471 14.6546 4.45477C13.0964 3.90485 11.4068 3.85235 9.81773 4.30444C8.22863 4.75654 6.81759 5.69121 5.77873 6.98059C5.43223 7.41065 4.8027 7.47839 4.37264 7.13189C3.94257 6.78539 3.87483 6.15586 4.22134 5.72579C5.5192 4.11494 7.28291 2.94623 9.27045 2.38078Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 8.99402C3.55229 8.99402 4 9.44173 4 9.99402V11.9985C4.00522 13.6565 4.52205 15.2721 5.47915 16.6232C6.43649 17.9748 7.78723 18.9953 9.34544 19.5453C10.9036 20.0952 12.5932 20.1477 14.1823 19.6956C15.7714 19.2435 17.1825 18.3088 18.2213 17.0194C18.5678 16.5894 19.1973 16.5216 19.6274 16.8681C20.0575 17.2146 20.1252 17.8442 19.7787 18.2742C18.4808 19.8851 16.7171 21.0538 14.7296 21.6192C12.742 22.1847 10.6286 22.119 8.67983 21.4312C6.73108 20.7435 5.04299 19.4676 3.84711 17.7793C2.65126 16.0911 2.00616 14.0732 2.00001 12.003L2 12H2V9.99402C2 9.44173 2.44772 8.99402 3 8.99402Z"
          fill={fill}
        />
      </svg>
    </i>
  );
}

export default ChangeIcon;
